import { Avatar, CircularProgress } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { getUpcomingBirthday } from '@/app/services/HomeService/homeService';
import { useDispatch } from 'react-redux';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import dayjs from 'dayjs';
import * as Actions from '@/app/store/actions';
import InfiniteScroll from 'react-infinite-scroll-component';
import { generateAgeString } from '@/utils/utils';

const UpcomingBirthdays = () => {
	const dispatch = useDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [rows, setRows] = useState([]);
	const [loadingMore, setLoadingMore] = useState(false);
	const [page, setPage] = useState(1);
	const [hasMore, setHasMore] = useState(false);
	const [viewAll, setViewAll] = useState(false);

	useEffect(() => {
		let isMounted = true;
		setIsLoading(true);
		getUpcomingBirthday(1)
			.then((res) => {
				if (!isMounted) return;
				setRows(res.data.data);
				if (res.data.next_page_url) {
					setHasMore(true);
					setPage(page + 1);
				}
			})
			.catch((err) => {
				if (!isMounted) return;
				console.log(err);
			})
			.finally(() => {
				if (!isMounted) return;
				setIsLoading(false);
			});

		return () => {
			isMounted = false;
		};
	}, [dispatch]);

	const handleLoadMore = () => {
		setLoadingMore(true);
		getUpcomingBirthday(page)
			.then(({ data }) => {
				setRows(rows.concat(data.data));
				if (data.next_page_url) {
					setHasMore(true);
					setPage(data.current_page + 1);
				} else {
					setHasMore(false);
				}
			})
			.catch((err) => {
				if (err.response?.data?.message) {
					dispatch(
						Actions.showMessage({
							message: err?.response?.data?.message,
							autoHideDuration: 2500,
							variant: 'error',
						}),
					);
				} else {
					dispatch(
						Actions.showMessage({
							message: 'Failed to load data',
							autoHideDuration: 2500,
							variant: 'error',
						}),
					);
				}
			})
			.finally(() => {
				setLoadingMore(false);
			});
	};

	return (
		<>
			<div className="child-man-div flex justify-between items-end">
				<h4
					className="font-extrabold self-end"
					style={{
						fontSize: '18px',
						fontWeight: '700',
					}}
				>
					Upcoming Birthdays
				</h4>
				<span className="cursor-pointer">
					{!viewAll && rows.length > 5 ? (
						<CustomButton
							fontSize="15px"
							onClick={() => setViewAll(true)}
							style={{
								justifyContent: 'space-evenly',
								display: 'flex',
								alignItems: 'center',
								height: '11px',
							}}
							variant="secondary"
						>
							View all <span className="chevron-right-icon">&#8250;</span>
						</CustomButton>
					) : (
						''
					)}
				</span>
			</div>
			<div
				className="inner-bdy MuiPaper-elevation1"
				style={{ paddingRight: '10px', paddingLeft: '10px', marginBottom: 100 }}
			>
				{isLoading ? (
					<div className="flex justify-center pt-64">
						<CircularProgress size={35} />
					</div>
				) : !rows?.length ? (
					<div className="flex justify-center pt-64">No Upcoming Birthdays</div>
				) : (
					<>
						<div className="pt-10 overflow-auto h-full" id="birthdays">
							{rows?.slice(0, viewAll ? rows.length : 5).map((row) => {
								return (
									<div
										className="flex justify-between p-16 pt-20 px-20 items-center my-auto"
										key={row.id}
										style={{ borderBottom: '1px solid rgba(224, 224, 224, 1)' }}
									>
										<div className="flex items-center">
											<Avatar className="mr-6" src={row.thumb} />
											<div
												className="flex flex-col items-start"
												style={{
													width: 130,
												}}
											>
												<div className="student-name-bday truncate break-word w-full">
													{row.first_name} {row.last_name}
												</div>
												<div className="font-normal truncate text-10 text-[#808080]" style={{ width: '90px' }}>
													{generateAgeString(row.date_of_birth)}
												</div>
											</div>
										</div>
										<div>{row.date_of_birth ? dayjs(row.date_of_birth).format('MMM, D') : '-'}</div>
									</div>
								);
							})}
							{loadingMore ? (
								<div className="flex justify-center">
									<CircularProgress size={35} />
								</div>
							) : null}
						</div>

						{viewAll ? (
							<InfiniteScroll
								dataLength={rows.length}
								hasMore={hasMore}
								next={handleLoadMore}
								scrollableTarget="birthdays"
							/>
						) : null}
					</>
				)}
			</div>
		</>
	);
};

export default UpcomingBirthdays;
